import { useEffect, useState } from 'react';
import { getLogger } from '@sas/nova-core/logging';
import { GenericKnownObject } from '@sas/react-svg';
const logger = getLogger('react-svg');

/**
 * Dynamically imports and returns `getIconFromRegisteredType` for more convenient
 * tree shaking.
 */
export const useGetIconFromRegisteredType = () => {
  // Use an anonymous function since React cannot tell the difference and will execute the "top level" function regardless
  // https://medium.com/swlh/how-to-store-a-function-with-the-usestate-hook-in-react-8a88dd4eede1
  const [lib, setLib] = useState(() => {
    return (_n, _t) => GenericKnownObject;
  });
  useEffect(() => {
    let ignoreImport = false;
    import( /* webpackMode: "lazy" */
    '@sas/react-svg/dynamic').then(i => {
      if (ignoreImport) return;
      // Requires the extra anonymous function wrapper because React will just call the getIconFromRegisteredType function otherwise
      setLib(() => i.getIconFromRegisteredType);
    }).catch(err => logger.error(err));
    return () => {
      ignoreImport = true;
    };
  }, []);
  return lib;
};
//# sourceMappingURL=useGetIconFromRegisteredType.js.map